// extracted by mini-css-extract-plugin
export default {"addClientTitle":"style_addClientTitle__-oh2-","addClientForm":"style_addClientForm__co2mn","addClientBtn":"style_addClientBtn__6P+gy","chooseProtocol":"style_chooseProtocol__hGl0Z"};